import { useMedplumProfile } from '@medplum/react-hooks';
import { LogOut, Menu, Moon, Sun } from 'lucide-react';
import { useSidebar } from '../../contexts/SidebarContext';
import { useTheme } from '../../contexts/ThemeContext';
import { medplum } from '../../medplum';
import { Button } from '../ui/button';

/** Top bar: page-agnostic actions (theme toggle, sign out, current user). */
export function Header() {
  const { resolvedTheme, toggleTheme } = useTheme();
  const { toggleMobileOpen } = useSidebar();
  const profile = useMedplumProfile();
  const displayName =
    profile && 'name' in profile && profile.name?.[0]
      ? [profile.name[0].given?.join(' '), profile.name[0].family].filter(Boolean).join(' ')
      : 'Signed in';

  return (
    <header className="flex h-16 items-center justify-between border-b border-border bg-card px-3 md:px-6">
      <div className="flex items-center gap-1">
        {/* Phone/tablet: opens the off-canvas nav drawer (#83). */}
        <Button
          variant="ghost"
          size="icon"
          className="md:hidden"
          onClick={toggleMobileOpen}
          aria-label="Open navigation"
          data-testid="nav-toggle"
        >
          <Menu className="h-5 w-5" />
        </Button>
        <div className="text-sm font-medium text-muted-foreground" data-testid="header-title">
          <span className="font-semibold text-foreground">Fluent</span> MedOps
        </div>
      </div>
      <div className="flex items-center gap-3">
        <span className="hidden text-sm text-muted-foreground sm:inline">{displayName}</span>
        <Button variant="ghost" size="icon" onClick={toggleTheme} aria-label="Toggle theme" title="Toggle light/dark">
          {resolvedTheme === 'dark' ? <Sun className="h-5 w-5" /> : <Moon className="h-5 w-5" />}
        </Button>
        <Button
          variant="ghost"
          size="icon"
          onClick={() => {
            void medplum.signOut();
          }}
          aria-label="Sign out"
          title="Sign out"
        >
          <LogOut className="h-5 w-5" />
        </Button>
      </div>
    </header>
  );
}
